import { Box, Button, Center, Heading, Text, VStack } from '@chakra-ui/react';

import Page from '@inspire/ui/chakra/layout/Page';

import { OnlyForSsoRegistered } from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import StandaloneCheckbox from '@inspire/ui/chakra/forms/StandaloneCheckbox';
import { useState } from 'react';
import LinkButton from 'components/general/LinkButton';
import { INSCRIPTION_ECLAIREUR_PROFILE_PATH } from 'lib/paths';
import {
  GTM_ACTION_INSCRIPTION_ECLAIREUR,
  GTM_CATEGORY_INSCRIPTION,
  pushEvent,
} from 'lib/gtm';

const InscriptionEclaireurPage = () => {
  const [charteCheckbox, setCharteCheckbox] = useState(false);
  const [messagesCheckbox, setMessagesCheckbox] = useState(false);
  return (
    <Page title="Avant d’aller plus loin..." withPanel headingIsTitle>
      <Text>
        Article 1 est une association d’égalité des chances. Pour son programme
        d’aide à l’orientation, elle s’appuie sur l’engagement d’une large
        communauté d’étudiants Éclaireurs bénévoles.
      </Text>

      <Heading size="md" mt={8} mb={4} textAlign="center">
        En étant Éclaireur bénévole Article 1, tu t’engages à être :
      </Heading>

      <VStack spacing={5}>
        <Box textAlign="center">
          <Heading size="sm" my={1}>
            A l’écoute !
          </Heading>
          <Text m={0}>Lis attentivement les questions des lycéens.</Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Réactif !
          </Heading>
          <Text m={0}>Réponds sous 72h aux lycéens.</Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Rassurant !
          </Heading>
          <Text m={0}>
            Ils sont un peu paniqués avant d’entrer dans le supérieur.
          </Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Bienveillant !
          </Heading>
          <Text m={0}>
            Sois indulgent envers les lycéens et leurs questions parfois qui
            pourront te paraître absurdes ou à côté de la plaque.
          </Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Objectif !
          </Heading>
          <Text m={0}>Prends du recul sur ta propre expérience.</Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Neutre !
          </Heading>
          <Text m={0}>
            Pas de pub ni de dénigrement des établissements. Et n’invente pas si
            tu ne sais pas :)
          </Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Tolérant !
          </Heading>
          <Text m={0}>
            Si les lycéens ont des conceptions différentes des tiennes, ça
            n’empêche pas de continuer l’échange.
          </Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Respectueux !
          </Heading>
          <Text m={0}>
            … des valeurs d’Article 1 et des règles de politesse.
          </Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            A jour !
          </Heading>
          <Text m={0}>Mets à jour ton profil de temps en temps.</Text>
        </Box>

        <Box textAlign="center">
          <Heading size="sm" m={1}>
            Garant de la sécurité !
          </Heading>
          <Text m={0}>
            Tous les échanges doivent se faire sur INSPIRE pour garantir leur
            sécurité.
          </Text>
        </Box>
      </VStack>
      <StandaloneCheckbox
        isChecked={charteCheckbox}
        mt={8}
        mb={4}
        label="Je m’engage à respecter la charte des étudiants Éclaireurs sur INSPIRE."
        onChange={async () => {
          setCharteCheckbox(!charteCheckbox);
        }}
      />
      <StandaloneCheckbox
        isChecked={messagesCheckbox}
        mb={4}
        label="Je m’engage à répondre aux messages des lycéens dans un délai de 72h."
        onChange={async () => {
          setMessagesCheckbox(!messagesCheckbox);
        }}
      />
      <Center>
        {messagesCheckbox && charteCheckbox ? (
          <LinkButton
            href={INSCRIPTION_ECLAIREUR_PROFILE_PATH}
            onClick={() =>
              pushEvent(
                GTM_CATEGORY_INSCRIPTION,
                GTM_ACTION_INSCRIPTION_ECLAIREUR,
                'Je valide la charte'
              )
            }
          >
            Continuer
          </LinkButton>
        ) : (
          <Button isDisabled={true}>Continuer</Button>
        )}
      </Center>
    </Page>
  );
};

InscriptionEclaireurPage.getWrappers = (page) => (
  <Layout rowVariant="yellow" containerWidth="md">
    <OnlyForSsoRegistered>{page}</OnlyForSsoRegistered>
  </Layout>
);

export default InscriptionEclaireurPage;
